import { SendReportsPayload } from '@/modules/Telemedicine/pages/MedicalRecord/components/SendMedicalRecordsModal/SendMedicalRecordsModal.types'

class SendMedicalRecordsMapper {
  toPersistence(domainData: SendReportsPayload) {
    return {
      email: domainData?.email,
      idPatient: domainData?.patientId,
      idAppointments: domainData?.appointmentsId,
    }
  }
}

export default new SendMedicalRecordsMapper()
